import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "./Logo";
import { siteConfig } from "../config/siteConfig";

export const Footer = () => {
  return (
    <footer
      className="bg-[#0f2a4a] text-slate-200 mt-20"
      data-testid="site-footer"
    >
      <div className="container-site py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo light />
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            {siteConfig.footer.description}
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold mb-4 tracking-wide uppercase">
            Navegação
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/" className="hover:text-green-400">
                Home
              </Link>
            </li>
            <li>
              <Link to="/sobre" className="hover:text-green-400">
                Sobre
              </Link>
            </li>
            <li>
              <Link to="/servicos" className="hover:text-green-400">
                Serviços
              </Link>
            </li>
            <li>
              <Link to="/contato" className="hover:text-green-400">
                Contato
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold mb-4 tracking-wide uppercase">
            Áreas Atendidas
          </h4>
          <ul className="space-y-2 text-sm text-slate-400">
            {siteConfig.contact.serviceAreas.map((a) => (
              <li key={a}>• {a}</li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold mb-4 tracking-wide uppercase">
            Contato
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-green-400 shrink-0" />
              <a
                href={`tel:${siteConfig.contact.phoneRaw}`}
                className="hover:text-green-400"
              >
                {siteConfig.contact.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-green-400 shrink-0" />
              <a
                href={`mailto:${siteConfig.contact.email}`}
                className="hover:text-green-400"
              >
                {siteConfig.contact.email}
              </a>
            </li>
            <li className="flex items-start gap-2 text-slate-400">
              <MapPin className="w-4 h-4 mt-0.5 text-green-400 shrink-0" />
              <span>{siteConfig.contact.address}</span>
            </li>
            <li className="flex items-start gap-2 text-slate-400">
              <Clock className="w-4 h-4 mt-0.5 text-green-400 shrink-0" />
              <span>{siteConfig.contact.workingHours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site py-5 text-xs text-slate-400 flex flex-col sm:flex-row justify-between gap-3">
          <span>{siteConfig.footer.copyright}</span>
          <span>
            Emergências{" "}
            <a
              href={`tel:${siteConfig.contact.phoneRaw}`}
              className="text-green-400 font-bold"
            >
              {siteConfig.contact.phone}
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
